<div *ngIf="!this.loader.isLoading()" class="register">
  <div class="register-container">

    <div class="custom-tabs">
      <div class="tab-item" (click)="showLoginForm()" [class.active]="!isRegister">
        Iniciar sesión
      </div>
      <div class="tab-item" (click)="showRegisterForm()" [class.active]="isRegister" style="color: #e74c3c;">
        Registrarme
      </div>
    </div>

    <div class="tab-underline">
      <div class="active-line" [ngClass]="{'left': !isRegister, 'right': isRegister}"></div>
    </div>

    <form [formGroup]="form" *ngIf="isRegister" (ngSubmit)="register()">

      <div class="social-login-section">
        <div class="social-buttons">
          <button type="button" class="social-button google" (click)="onGoogleLogin()">
            <img src="assets/icons/google-logo.png" alt="Google" class="google-icon">
          </button>
          <!-- <button type="button" class="social-button linkedin" (click)="redirectLinkedIn()">
            in
          </button> -->
        </div>
      </div>

      <div class="divider">
        <div class="line"></div>
        <div class="circle">O</div>
        <div class="line"></div>
      </div>

      <div class="form-fields">
        <div class="field-group">
          <label>Nombre y apellido</label>
          <input type="text" placeholder="Ingrese nombre (s) y apellidos" formControlName="name" />
          <div *ngIf="registerName?.invalid && (registerName?.dirty || registerName?.touched)"
            class="validation-input-error">
            <p *ngIf="registerName?.errors?.['required']">Ingrese su nombre</p>
          </div>
        </div>

        <div class="field-group">
          <label>Correo electrónico</label>
          <input type="email" placeholder="Ingrese correo electrónico" formControlName="email" />
          <div *ngIf="registerEmail?.invalid && (registerEmail?.dirty || registerEmail?.touched)"
            class="validation-input-error">
            <p *ngIf="registerEmail?.errors?.['required']">Ingrese correo electrónico</p>
            <p *ngIf="registerEmail?.errors?.['email']">
              Por favor, ingrese un correo electrónico válido
            </p>
          </div>
        </div>

        <div class="field-group">
          <label>Contraseña</label>
          <div class="password-container">
            <input [type]="passwordVisible ? 'text' : 'password'" placeholder="Ingrese contraseña"
              formControlName="password" maxlength="16" (input)="checkPassword($event); checkPasswordsMatch()" />
            <svg class="toggle-password-icon" (click)="togglePasswordVisibility()" [class.visible]="passwordVisible"
              [class.hidden]="!passwordVisible" viewBox="0 0 24 24" fill="currentColor">
              <!-- Icono de ojo abierto -->
              <path *ngIf="passwordVisible" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              <!-- Icono de ojo cerrado -->
              <path *ngIf="!passwordVisible" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
            </svg>
          </div>
          <div *ngIf="registerPassword?.value && registerPassword?.value.length>=8" class="password-strong-container">
            <div #pointer id="password-pointer"></div>
          </div>
          <div *ngIf="registerPassword?.invalid && (registerPassword?.dirty || registerPassword?.touched)"
            class="validation-input-error">
            <p *ngIf="registerPassword?.errors?.['required']">Ingrese la contraseña</p>
            <p *ngIf="registerPassword?.errors?.['minlength'] || registerPassword?.errors?.['pattern']">La contraseña
              debe
              tener al menos 8 caracteres, incluyendo una mayúscula, un número y un carácter especial</p>
          </div>
        </div>

        <div class="field-group">
          <label>Confirmar contraseña</label>
          <div class="password-container">
            <input [type]="confirmPasswordVisible ? 'text' : 'password'" placeholder="Confirme contraseña"
              formControlName="confirmPassword" maxlength="16" (input)="checkPasswordsMatch()" />
            <svg class="toggle-password-icon" (click)="toggleConfirmPasswordVisibility()"
              [class.visible]="confirmPasswordVisible" [class.hidden]="!confirmPasswordVisible" viewBox="0 0 24 24" fill="currentColor">
              <!-- Icono de ojo abierto -->
              <path *ngIf="confirmPasswordVisible" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              <!-- Icono de ojo cerrado -->
              <path *ngIf="!confirmPasswordVisible" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
            </svg>
          </div>
          <div
            *ngIf="registerConfirmPassword?.invalid && (registerConfirmPassword?.dirty || registerConfirmPassword?.touched)"
            class="validation-input-error">
            <p *ngIf="registerConfirmPassword?.errors?.['required']">Confirme la contraseña</p>
            <p *ngIf="registerConfirmPassword?.errors?.['passwordMismatch']">Las contraseñas no coinciden</p>
          </div>
          <div *ngIf="passwordsMatch && registerConfirmPassword?.value" class="validation-input-success">
            <p>✓ Contraseñas correctas</p>
          </div>
        </div>

        <div class="terms-checkbox">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="acceptTerms" class="checkbox-input">
            <span class="checkmark"></span>
            <span class="terms-text">
              Al aceptar declaro que he leído y aceptado los
              <a (click)="redirectTermsConditions()" class="link">Términos y Condiciones</a>
              y
              <a (click)="redirectPrivacyPolicies()" class="link">Políticas de Privacidad</a>
            </span>
          </label>
        </div>

        <button class="boton-principal" [disabled]="form.invalid || !form.get('acceptTerms')?.value"
          type="submit">Registrarme</button>
      </div>
    </form>


    <!-- <button class="boton-secundario">
       <i class="fa-brands fa-apple"></i>
       Regístrate con Apple
     </button> -->
    <!-- <div class="contact-us">
      <a href="#" [routerLink]="['/contact-us']">Contáctanos</a>
    </div> -->

    <form [formGroup]="singInForm" *ngIf="!isRegister" (ngSubmit)="onLocalLogin()">

      <div class="social-login-section">
        <div class="social-buttons">
          <button type="button" class="social-button google" (click)="onGoogleLogin()">
            <img src="assets/icons/google-logo.png" alt="Google" class="google-icon">
          </button>
          <!-- <button type="button" class="social-button linkedin" (click)="redirectLinkedIn()">
            in
          </button> -->
        </div>
      </div>

      <div class="divider">
        <div class="line"></div>
        <div class="circle">o</div>
        <div class="line"></div>
      </div>

      <div class="form-fields">
        <div class="field-group">
          <label>Correo electrónico</label>
          <input type="email" placeholder="Ingrese correo electrónico" formControlName="username" />
          <div *ngIf="singInUsername?.invalid && (singInUsername?.dirty || singInUsername?.touched)"
            class="validation-input-error">
            <p *ngIf="singInUsername?.errors?.['required']">Ingrese correo electrónico.</p>
            <p *ngIf="singInUsername?.errors?.['email']">
              Por favor, ingrese un correo electrónico válido
            </p>
          </div>
        </div>

        <div class="field-group">
          <label>Contraseña</label>
          <div class="password-container">
            <input [type]="passwordVisible ? 'text' : 'password'" placeholder="Ingrese contraseña"
              formControlName="password" maxlength="16" />
            <svg class="toggle-password-icon" (click)="togglePasswordVisibility()" [class.visible]="passwordVisible"
              [class.hidden]="!passwordVisible" viewBox="0 0 24 24" fill="currentColor">
              <!-- Icono de ojo abierto -->
              <path *ngIf="passwordVisible" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
              <!-- Icono de ojo cerrado -->
              <path *ngIf="!passwordVisible" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
            </svg>
          </div>
          <div *ngIf="singInPassword?.invalid && (singInPassword?.dirty || singInPassword?.touched)"
            class="validation-input-error">
            <p *ngIf="singInPassword?.errors?.['required']">Ingrese la contraseña.</p>
          </div>
        </div>

        <div class="forgot-password">
          <a (click)="navigateToRecoverPassword()" class="link">Olvide mi contraseña</a>
        </div>

        <div class="terms-checkbox">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="acceptTerms" class="checkbox-input">
            <span class="checkmark"></span>
            <span class="terms-text">
              Al aceptar declaro que he leído y aceptado los
              <a (click)="redirectTermsConditions()" class="link">Términos y Condiciones</a>
              y
              <a (click)="redirectPrivacyPolicies()" class="link">Políticas de Privacidad</a>
            </span>
          </label>
        </div>

        <button [disabled]="singInForm.invalid || !singInForm.get('acceptTerms')?.value" class="boton-principal" type="submit">Iniciar sesión</button>
      </div>
    </form>




    <!-- <button class="boton-secundario">
      <i class="fa-brands fa-apple"></i>
      Iniciar Sesión con Apple
    </button> -->

    <!-- <div class="contact-us">
      <a href="#" [routerLink]="['/contact-us']">Contáctanos</a>
    </div> -->

    <!-- Footer con versión del sistema -->
    <!-- 
      Atajos de teclado para borrar cookies y datos del navegador:
      
      CHROME / EDGE (Chromium):
      - Ctrl + Shift + Delete (Windows/Linux)
      - Cmd + Shift + Delete (Mac)
      - O presiona F12 > Application > Storage > Clear site data
      
      FIREFOX:
      - Ctrl + Shift + Delete (Windows/Linux)
      - Cmd + Shift + Delete (Mac)
      - O presiona F12 > Storage > Cookies > Click derecho > Delete All
      
      SAFARI:
      - Cmd + Option + E (Mac) - Borrar historial y cookies
      - O Safari > Preferencias > Privacidad > Gestionar datos de sitios web
      
      OPERA:
      - Ctrl + Shift + Delete (Windows/Linux)
      - Cmd + Shift + Delete (Mac)
      - O presiona F12 > Application > Storage > Clear site data
      
      BRAVE:
      - Ctrl + Shift + Delete (Windows/Linux)
      - Cmd + Shift + Delete (Mac)
      
      Para forzar recarga sin cache (Hard Refresh):
      - Ctrl + Shift + R (Windows/Linux)
      - Cmd + Shift + R (Mac)
    -->
    <div class="version-footer">
      <div *ngIf="hasVersion && appVersion" class="version-label">
        Versión: {{ appVersion }}
      </div>
      <!-- <button *ngIf="!hasVersion" 
              type="button" 
              class="update-button" 
              (click)="clearCookiesAndReload()">
        Actualiza tu Aplicativo
      </button> -->
    </div>

  </div>
</div>